import * as yup from 'yup';

export function canUpdateOrDelete(user, entity, permission, action) {
    if (!user) {
        return false;
    }
    if (!entity.shared) {
        if (
            entity.shared_users &&
            Array.isArray(entity.shared_users) &&
            entity.shared_users.some((share) => share.user_id === user.id)
        ) {
            return false;
        }

        if (entity.user?.id === user.id) {
            return true;
        }
    } else {
        const sharedOrgIds = entity.shared_organizations;

        if (!sharedOrgIds || sharedOrgIds.length === 0) {
            return false;
        }

        return hasPermission(user, permission, action, sharedOrgIds);
    }

    return false;
}

export function hasPermission(user, permission, action, organizationIds = null) {
    if (!user || !user.role || !user.role.permissions) {
        return false;
    }

    let { permissions } = user.role;
    if (organizationIds && Array.isArray(organizationIds)) {
        permissions = permissions.filter((p) => organizationIds.includes(p.organization_id));
    }

    return permissions.some((p) => p.permission === permission && p[action] === true);
}

export const PROFILE_SCHEMA = yup.object().shape({
    name: yup.string().required(),
    email: yup.string().email('Email must be a valid email.').required(),
    social_links: yup
        .array()
        .of(
            yup.object().shape({
                type: yup.string().optional(),
                url: yup.string().optional()
            })
        )
        .optional()
});
